import firebase from 'firebase/compat/app'
import { Cohort } from 'nove8/constants/root-constants'
import { getRemoteConfigVariantData } from 'nove8/helpers/getRemoteConfigVariantData'
import { FirebaseRemoteConfigKey, TestGroup, LOCALES } from 'root-constants'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const isCoachSelectionTestVariant = (
  firebaseRemoteConfig?: firebase.remoteConfig.RemoteConfig | null,
): boolean => {
  const {
    firebaseRemoteConfig: storeRemoteConfig,
    lead,
    initialCohort,
  } = useZustandStore.getState()
  const cohort = lead?.cohort || initialCohort
  const langFromUrl = new URL(window.location.href).searchParams.get('lang')
  const language = langFromUrl || useZustandSessionStore.getState().language

  if (cohort !== Cohort.WOOFZ_WOOFY1 || language !== LOCALES.EN) {
    return false
  }

  const segment = getRemoteConfigVariantData({
    firebaseRemoteConfig: firebaseRemoteConfig ?? storeRemoteConfig,
    firebaseRemoteConfigKey: FirebaseRemoteConfigKey.ABTEST_WEB_3_WOOFY,
  })

  return segment?.toString() === TestGroup.ABTEST_WEB_3_B_COACH_FLOW
}
